<template>
  <span>
    <ConnectedAccountOnboardingModal
      title="googleads"
      :logo="googleads"
      :success="success"
      :error="error"
      :logo-alt="$t('components.connectGoogleAds.googleAdsLogo')"
      @click="openModal"
    />

    <!-- Google Ads Modal -->
    <ModalGoogleads
      ref="googleadsModal"
      @submit="continueGoogleAdsIntegration"
      @error="$emit('error', MARKETING_PLATFORMS.GOOGLEADS)"
      @modalAction="
        (platformName, action) => $emit('modalAction', platformName, action)
      "
    />
  </span>
</template>

<script>
import { MARKETING_PLATFORMS } from '@/data/platforms';

import ModalGoogleads from '@/pages/connected-accounts/components/modals/ModalGoogleads.vue';
import ConnectedAccountOnboardingModal from '@/pages/connected-accounts/components/ConnectedAccountOnboardingModal.vue';

import googleIcon from '@/assets/logos/google.png';

export default {
  components: {
    ConnectedAccountOnboardingModal,
    ModalGoogleads,
  },
  props: {
    authorizeUri: {
      type: String,
      required: true,
    },
    success: Boolean,
    error: Boolean,
  },
  computed: {
    googleads: () => googleIcon,
    MARKETING_PLATFORMS: () => MARKETING_PLATFORMS,
  },
  methods: {
    openModal() {
      this.$refs.googleadsModal.open();
    },
    async continueGoogleAdsIntegration(customerId) {
      this.$emit('submit', {
        authorizeUri: this.authorizeUri,
        extras: customerId,
      });
    },
  },
};
</script>
